import { createContext, useState } from "react";

const DocumentationContext = createContext({
  numero: "",
  anio: "",
  documento: "",
  archivos: [],
  telefono: '',
  email: '',
  updateForm: (numero, anio, documento) => {},
  updateArchivos: (archivos) => {},
  updateContacto: (telefono, email) => {}
});

export function DocumentationContextProvider(props) {
  // State
  const [numero, setNumero] = useState();
  const [anio, setAnio] = useState();
  const [documento, setDocumento] = useState();
  const [archivos, setArchivos] = useState([]);
  const [telefono, setTelefono] = useState();
  const [email, setEmail] = useState();

  // Methods
  const updateForm = (numero, anio, documento) => {
    setNumero(numero);
    setAnio(anio);
    setDocumento(documento);
  };

  const updateArchivos = (archivos) => {
    setArchivos(archivos);
  };

  const updateContacto = (telefono, email) => {
    setTelefono(telefono);
    setEmail(email);
  };

  const context = {
    numero: numero,
    anio: anio,
    documento: documento,
    archivos: archivos,
    telefono: telefono,
    email: email,
    updateForm: updateForm,
    updateArchivos: updateArchivos,
    updateContacto: updateContacto
  };

  return (
    <DocumentationContext.Provider value={context}>
      {props.children}
    </DocumentationContext.Provider>
  );
}

export default DocumentationContext;
